import React from "react";
import { ButtonComponent } from "@/components";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesPathList } from "@/config/routes/Routes.tsx";
import { isSNS } from "@/utils/utils";
import bgSNS from "../assets/SVG/bgSNS.svg";
import bgSuccess from "../assets/SVG/bgSuccess.svg";
import successSNS from "../assets/SVG/successSNS.svg";

type LocationState = {
  transaction_id: string;
  isComingFromTransactionApproved: boolean;
};

const ExchangeSuccess: React.FC = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const state = location.state as LocationState | undefined;
  const isComingFromTransactionApproved =
    location.state?.isComingFromTransactionApproved ?? false;

  return !isSNS() ? (
    <div className="overflow-hidden min-h-screen bg-[#F3F3F3] flex items-center flex-col justify-between h-screen p-12">
      <div className="flex justify-center h-full flex-col items-center gap-10">
        <svg
          width="97"
          height="98"
          viewBox="0 0 97 98"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3090_6253)">
            <path
              d="M97.0905 0V77.7352H73.0174L76.7356 73.9749H93.2835V3.85018H23.9194V20.3418L20.2266 24.0636V0H97.0905Z"
              fill="#202A43"
            />
            <mask
              id="mask0_3090_6253"
              maskUnits="userSpaceOnUse"
              x="20"
              y="0"
              width="78"
              height="78"
            >
              <path
                d="M97.0905 0V77.7352H73.0174L76.7356 73.9749H93.2835V3.85018H23.9194V20.3418L20.2266 24.0636V0H97.0905Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_3090_6253)">
              <path
                d="M93.2837 3.85018L97.0907 0V77.7352H73.0176L76.7358 73.9749H93.2837V3.85018Z"
                fill="url(#paint0_linear_3090_6253)"
              />
            </g>
            <path
              d="M64.4784 32.8291V77.273L43.9712 97.9999V53.6073H0L20.5707 32.8291H64.4784Z"
              fill="#202A43"
            />
            <mask
              id="mask1_3090_6253"
              maskUnits="userSpaceOnUse"
              x="0"
              y="32"
              width="65"
              height="66"
            >
              <path
                d="M64.4784 32.8291V77.273L43.9712 97.9999V53.6073H0L20.5707 32.8291H64.4784Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_3090_6253)">
              <path
                d="M43.9727 53.6073L64.4799 32.8291V77.273L43.9727 97.9999V53.6073Z"
                fill="url(#paint1_linear_3090_6253)"
              />
            </g>
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_3090_6253"
              x1="85.0605"
              y1="-4.31221"
              x2="85.0605"
              y2="76.5673"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.09" stop-color="#4A68A7" />
              <stop offset="0.73" stop-color="#1E2A43" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3090_6253"
              x1="54.2263"
              y1="30.6858"
              x2="54.2263"
              y2="95.7796"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.06" stop-color="#4A68A7" />
              <stop offset="0.73" stop-color="#1E2A43" />
            </linearGradient>
            <clipPath id="clip0_3090_6253">
              <rect width="97" height="98" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div className="text-center">
          <h1 className="text-[1.6875rem] text-[#222B45] font-[700] mb-4 font-satoshi">
            Successfully Exchanged!
          </h1>
        </div>
      </div>

      <ButtonComponent
        title={"Next"}
        actionCallback={() => {
          navigate(RoutesPathList.ReceiptPOS, {
            state: {
              transaction_id: state?.transaction_id,
              isComingFromTransactionApproved: isComingFromTransactionApproved,
            },
          });
        }}
        name={`button--classic w-[10.5rem] text-center !bg-[#222b45] !text-white`}
      />
    </div>
  ) : (
    <div
      className="relative overflow-hidden min-h-screen font-[helvetica] w-full bg-[#1C1C1C] pb-[4rem] flex flex-col justify-between items-center"
      style={{
        backgroundImage: `url(${bgSNS})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <img className="absolute z-10" src={bgSuccess} />
      <div className="flex justify-center z-10 h-full flex-col items-center mt-[7rem]">
        <img className="z-10 w-[8rem]" src={successSNS} />
        <div className="text-center z-10">
          <h1 className="text-[1.6875rem] text-white mb-4 font-[helvetica]">
            Successfully <br />
            Exchanged!
          </h1>
        </div>
      </div>

      <ButtonComponent
        title={"Next"}
        actionCallback={() => {
          navigate(RoutesPathList.ReceiptPOS, {
            state: {
              transaction_id: state?.transaction_id,
              isComingFromTransactionApproved: isComingFromTransactionApproved,
            },
          });
        }}
        name={`z-10 w-[19.4375rem] text-center button_pink font-[helvetica] !text-white`}
      />
    </div>
  );
};

export default ExchangeSuccess;
